/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';
import Localized from '../../../shared/components/Localized';
import Modal from './index';
import { ModalHeader } from './index';

export default class DismissModal extends React.Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    closeModal: PropTypes.func,
    isOpen: PropTypes.bool,
    header: PropTypes.object,
    body: PropTypes.object
  };

  render() {
    const { closeModal } = this.props;

    return (
      <Modal isOpen={true} onClose={closeModal}>
        <ModalHeader>
            <h2 className='slds-text-heading--medium'>
               <Localized
                modelName='subscribeModal'
                modelKey='subscribe'
                modelAttribute='label'
              />
            </h2>
        </ModalHeader>
        <div className='slds-modal__content-footer'>
          <div className='slds-m-left--large slds-m-right--medium slds-text-heading--x-small slds-modal__header'>
            <span className='slds-m-right--medium '>
              <Localized
                modelName='subscribeModal'
                modelKey='subscribeSuccess'
                modelAttribute='value'
              />
            </span>
          </div>
        </div>
        <div className="slds-modal__footer">
          <div className="slds-x-small-buttons--horizontal modal-footer-center">
            <button className="slds-button slds-button--brand " onClick={closeModal}>
              <Localized modelName={'modal'} modelKey={'dismiss'} modelAttribute={'label'} />
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
